import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Box, Container } from '@mui/material';
import Navbar from './components/Navbar';
import Dashboard from './pages/Dashboard';
import NodeDetail from './pages/NodeDetail';
import GPUDetail from './pages/GPUDetail';
import ClusterOverview from './pages/ClusterOverview';

function App() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navbar />
      <Container component="main" sx={{ flexGrow: 1, py: 4 }}>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/node/:nodeId" element={<NodeDetail />} />
          <Route path="/gpu/:gpuId" element={<GPUDetail />} />
          <Route path="/clusters" element={<ClusterOverview />} />
        </Routes>
      </Container>
    </Box>
  );
}

export default App; 